<template>
  <div class="center-map" ref="boxRef" v-if="isShow">

    <div class="header-box">
      <div class="left-btn">
        <span @click="btnClcik('默认')" :class="{ active: tabName === '默认' }">默认</span>
        <span @click="btnClcik('雨情')" :class="{ active: tabName === '雨情' }">雨情</span>
        <span @click="btnClcik('预警')" :class="{ active: tabName === '预警' }">预警</span>
      </div>
      <div class="right-message">
        <img src="@/assets/images/雨情信息.png" alt="">
        <span>{{ yqCon ? yqCon : '暂无雨情' }}</span>
      </div>
    </div>

    <div class="img-box">
      <img class="image" v-show="tabName === '默认' && theme === 'dark'" src="@/assets/images/深色地图.png" alt="">
      <img class="image" v-show="tabName === '默认' && theme === 'light'" src="@/assets/images/浅色地图.png" alt="">
      <img class="image" v-show="tabName === '雨情'" :src="`${base_url}/rainPic/R${tabIndex}H.jpg`" alt="">
      <img class="image more-image" v-show="tabName === '雨情' && theme === 'dark'" src="@/assets/images/地图-深色镂空.png"
        alt="">
      <img class="image more-image" v-show="tabName === '雨情' && theme === 'light'" src="@/assets/images/地图-浅色镂空.png"
        alt="">

      <div v-show="tabName === '雨情'" class="yuqing-time">{{ $moment(timelong).format('YYYY年MM月DD日HH时mm分') }}全市{{
        tabIndex }}小时雨量分布图</div>
      <div class="h-time" v-show="tabName === '雨情'">
        <span :class="{ active: tabIndex === '01' }" @click="tabIndex = '01'">1小时</span>
        <span :class="{ active: tabIndex === '03' }" @click="tabIndex = '03'">3小时</span>
        <span :class="{ active: tabIndex === '06' }" @click="tabIndex = '06'">6小时</span>
        <span :class="{ active: tabIndex === '12' }" @click="tabIndex = '12'">12小时</span>
        <span :class="{ active: tabIndex === '24' }" @click="tabIndex = '24'">24小时</span>
      </div>

      <div class="yubao-tuli" v-show="tabName === '雨情'">
        <img v-show="Number(tabIndex) < 7" src="@/assets/images/深色图例1.png" alt="">
        <img v-show="Number(tabIndex) > 7" src="@/assets/images/深色图例2.png" alt="">
      </div>

      <div class="warrning-map" v-show="tabName === '预警'">
        <div id="echart"></div>
        <div class="warning-image">
          <div class="item1" v-for="item, index in alarmIcon" :key="item" @click="getColor(index)">
            <img :src="require('@/assets/images/alarmicon/' + item + '.gif')"
              :class="{ 'active': index === activeIconIndex }" />
          </div>
        </div>

        <div class="alarm-right-tip">
          <div class="alarn-item" v-for="item in rightAlarnColor" :key="item.name">
            <span :style="{ background: item.sigcolor }"></span>
            <span>{{ item.name }}</span>
          </div>
        </div>
      </div>
    </div>

    <div v-for="item in pointList" :key="item.id" class="icon-item" :style="{ left: item.left, bottom: item.bottom }"
      v-show="tabName !== '预警'">
      <img v-if="(item.risklevel === 3 && item.status > 0 && theme === 'light')" src="@/assets/images/定位-黄.png" alt="">
      <img v-if="(item.risklevel === 2 && item.status > 0 && theme === 'light')" src="@/assets/images/定位-紫.png" alt="">
      <img v-if="(item.risklevel === 1 && item.status > 0 && theme === 'light')" src="@/assets/images/定位-红.png" alt="">
      <img v-if="((item.risklevel === 0 || item.status === 0) && theme === 'light')" src="@/assets/images/定位-蓝.png"
        alt="">
      <img v-if="(item.risklevel === 3 && item.status > 0 && theme === 'dark')" src="@/assets/images/定位-黄色.png" alt="">
      <img v-if="(item.risklevel === 2 && item.status > 0 && theme === 'dark')" src="@/assets/images/定位-紫色.png" alt="">
      <img v-if="(item.risklevel === 1 && item.status > 0 && theme === 'dark')" src="@/assets/images/定位-红色.png" alt="">
      <img v-if="((item.risklevel === 0 || item.status === 0) && theme === 'dark')" src="@/assets/images/定位-蓝色.png"
        alt="">
    </div>
  </div>

</template>

<script>
import echarts from '@/config/echarts/index.js'
import { apiData, jsonData } from '@/api'
export default {
  props: ['theme'],
  data() {
    return {
      // areas: ['越秀区', '海珠区', '荔湾区', '天河区', '黄埔区', '白云区', '花都区', '番禺区', '南沙区', '从化区', '增城区'],
      areas: ['禅城区', '南海区', '顺德区', '三水区', '高明区'],
      isShow: true,
      pointList: [],
      tabName: '默认',
      yqCon: '',
      echart: null,
      alarmIcon: [],
      alarnArea: {},
      WarningAreaColor: [],
      rightAlarnColor: [],
      countyAlarm: [],
      tabIndex: '01',
      timelong: new Date(),
      base_url: process.env.VUE_APP_DATA
    }
  },
  watch: {
    theme() {
      this.getColor(this.activeIconIndex)
    }
  },
  created() {
    this.objStatusByUnit()
    this.newestYqtbCont()
    this.newestYqtbTime()
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.isShow = false
      this.isShow = true
      this.$nextTick(() => {
        this.setPonitPosition()
      })
    })
  },
  methods: {
    async newestYqtbTime() {
      const result = await apiData.newestYqtbTime()
      this.timelong = result.timelong
    },
    /**
     * 加载图表
     */
    async loadEchart() {
      if (!this.echart) {
        const res = await jsonData.getFsMap()
        this.echart = echarts.init(document.getElementById('echart'))
        echarts.registerMap('gzMap', res)
      }
      const option = {
        geo: {
          itemStyle: {
            normal: {
              label: { show: true, textStyle: { color: '#000' } },
              borderColor: '#3762c3',
              borderWidth: 1.0,
              areaColor: this.theme === 'light' ? '#E8F6FC' : '#0f388a'
            }
          },
          emphasis: {
            label: { show: true, textStyle: { color: '#000000' } },
            itemStyle: {
              areaColor: this.theme === 'light' ? '#E8F6FC' : '#0f388a',
              shadowColor: 'rgba(0, 0, 0, 1)',
              shadowOffsetX: -2,
              shadowOffsetY: 2,
              shadowBlur: 10
            }
          },
          type: 'map',
          map: 'gzMap', // chinaMap需要和registerMap中的第一个参数保持一致
          roam: true, // 设置允许缩放以及拖动的效果
          aspectScale: 1,
          // label: {
          //   show: true // 展示标签
          // },
          zoom: 1.2, // 设置初始化的缩放比例
          regions: this.WarningAreaColor
        },
        series: [
          {
            type: 'map',
            map: '广州',
            geoIndex: 0,
            data: this.WarningAreaColor
          }
        ]
      }
      this.echart.resize()
      this.echart.setOption(option)
    },
    async objStatusByUnit() {
      const company = this.$route.query.company
      const { unit } = JSON.parse(localStorage.getItem(company))
      const result = await apiData.objStatusByUnit(unit.id)
      if (result.status === 200) {
        result.data = result.data.filter(item => {
          return item.lon <= 114.7 && item.lon >= 112.57 && item.lat <= 24.26 && item.lat >= 22.46
        })
        this.pointList = result.data
        this.$nextTick(() => {
          this.setPonitPosition(this.pointList)
        })
      }
    },
    /**
    * 正在生效的区县预警信号
    */
    async getCountyAlarm() {
      const countyAlarm = []
      const result = await apiData.countyAlarm()
      this.areas.forEach(item => {
        if (result[item]) {
          countyAlarm.push(...result[item])
        }
      })
      countyAlarm.forEach(item => {
        const alarnIcon = item.signame + item.siglevel
        const index = this.alarmIcon.findIndex(iten => iten.includes(item.signame))
        if (index < 0) {
          this.alarmIcon.push(alarnIcon)
        } else {
          const num = Number(this.alarmIcon[index].split('')[1])
          if (item.siglevel > num) {
            this.alarmIcon[index] = alarnIcon
          }
        }
      })
      this.countyAlarm = countyAlarm
      this.areas.forEach(area => {
        this.alarnArea[area] = []
        for (let i = 0; i < 4; i++) {
          const item = countyAlarm.find(item => (item.signame + item.siglevel) === this.alarmIcon[i] && item.county === area)
          if (item) {
            this.alarnArea[area].push(item.sigcolor)
          } else {
            this.alarnArea[area].push('#eaeef6')
          }
        }
      })

      this.entryLenght = 4 - this.alarmIcon.length
      this.getColor(0)
    },

    getColor(index) {
      this.activeIconIndex = index
      const WarningAreaColor = []
      this.rightAlarnColor = []
      const signame = this.alarmIcon[index]
      this.areas.forEach((street, index) => {
        let color = '#eaeef6'
        this.countyAlarm.forEach((alarm) => {
          if (alarm.county === street && signame.includes(alarm.signame)) {
            color = alarm.sigcolor
            const areaData = {
              name: street,
              aname: alarm.aname,
              ddatetime: alarm.ddatetime,
              sigcolor: alarm.sigcolor,
              // content: this.getAlarmContent(alarm.aname),
              itemStyle: {
                areaColor: alarm.sigcolor
              },
              emphasis: { itemStyle: { areaColor: alarm.sigcolor } }
            }
            WarningAreaColor.push(areaData)
          }
        })
        this.rightAlarnColor.push({ name: street.slice(0, 2), sigcolor: color })
      })
      this.WarningAreaColor = WarningAreaColor
      this.loadEchart()
    },
    // 设置信息点在图片上的位置
    setPonitPosition() {
      const boxRef = this.$refs.boxRef
      const imageWidth = boxRef.offsetWidth
      const imageHeight = boxRef.offsetHeight
      this.pointList = this.pointList.map((item, index) => {
        // 判断哪些是警报的点
        // if (item.dayHighTemp > 35 && item.dayHighTemp < 999) {
        //   this.baijingData.push(`${item.stationName}最高温度${item.dayHighTemp}`)
        // }
        // if (item.actTemp > 35 && item.dayHighTemp < 999) {
        //   this.baijingData.push(`${item.stationName}实时温度${item.actTemp}`)
        // }
        // if (item.r03H > 50 && item.dayHighTemp < 999) {
        //   this.baijingData.push(`${item.stationName}3h降雨量${item.r03H}`)
        // }
        // if (item.r20D > 50 && item.dayHighTemp < 999) {
        //   this.baijingData.push(`${item.stationName}24h降雨量${item.r20D}`)
        // }
        const londif = (item.lon - 112.57) / (114.46 - 112.57) * 100
        item.left = (imageWidth / 100 * londif) + 'px'
        const latdif = (item.lat - 22.06) / (24.56 - 22.06) * 100
        item.bottom = (imageHeight / 100 * latdif) + 'px'
        item.show = true
        return item
      })
    },

    // 获取雨晴通报最新内容
    async newestYqtbCont() {
      const company = this.$route.query.company
      const { unit } = JSON.parse(localStorage.getItem(company))
      const result = await apiData.newestYqtbCont(unit.id)
      if (result.status === 200) {
        this.yqCon = result.data
      }
    },

    btnClcik(type) {
      this.tabName = type
      if (type === '预警') {
        this.getCountyAlarm()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.center-map {
  display: flex;
  justify-content: center;
  // align-items: center;
  position: absolute;
  width: 100%;
  height: 100vh;
  top: -8.2vh;

  .yuqing {
    position: relative;
    top: 8vh;
    left: 50%;
    height: 80%;
    transform: translateX(-60%);
  }

  .header-box {
    display: flex;
    position: absolute;
    top: 0;
    left: 1.56vw;
    width: 100%;
    box-sizing: border-box;
    padding-top: 1.04vw;
    padding-left: 5.21vw;

    .left-btn {
      display: flex;
      margin-right: 2.45vw;

      span {
        width: 5vw;
        height: 2.29vw;
        box-sizing: border-box;
        margin-right: 0.52vw;
        font-size: 0.83vw;
        line-height: 2.29vw;
        text-align: center;
        background: #FFF;
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.07);
        color: #666666;
        border-radius: 0.31vw;
      }

      span.active {
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.07);
        border-radius: 6px;
        border: 1px solid #2D74F5;
        color: #2D74F5;
      }
    }

    .right-message {
      display: flex;
      align-items: center;
      flex: 1;
      font-size: 0.94vw;
      font-weight: 400;
      color: #FF882D;

      img {
        width: 1.04vw;
        max-height: 1.09vw;
        margin-right: 0.26vw;
      }

      span {
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
      }
    }
  }

  .img-box {
    width: 47.2vw;
    height: calc(91vh - 53px);
    position: relative;
    top: 8.2vh;

    .image {
      position: absolute;
      top: 0px;
      left: 50%;
      height: 100%;
      transform: translateX(-50%);
    }

    .more-image {
      height: calc(100% + 2px);
    }

    .warrning-map {
      width: 100%;
      height: 100%;
      position: relative;

      #echart {
        width: 100%;
        height: 100%;
      }

      .warning-image {
        position: absolute;
        top: 1.56vw;
        left: 4.17vw;
        z-index: 999;
        margin-top: 1.56vw;
        display: flex;
        flex-direction: column;

        .item1 {
          width: 3.13vw;
          height: 2.5vw;
          margin-bottom: 1.56vw;

          img {
            width: 3.13vw;
            height: 2.5vw;

            &:hover {
              cursor: pointer;
            }
          }

          .active {
            box-sizing: border-box;
            border: 2px solid #00ddff;
          }
        }
      }

      .alarm-right-tip {
        position: absolute;
        right: 0px;
        bottom: 0px;
        top: 50%;
        padding: 5px;
        display: flex;
        flex-direction: column;
        background: #FFFFFF;
        color: #333333;
        box-shadow: 0px 0px 9px 0px rgba(200, 200, 200, 0.5);

        border-radius: 4px;

        .alarn-item {
          flex: 1;

          span {
            font-size: 0.73vw;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
          }

          span:nth-child(1) {
            display: inline-block;
            margin-right: 0.52vw;
            width: 1.61vw;
            height: 0.78vw;
            border-radius: 0.31vw;
          }

        }
      }
    }
  }

  .icon-item {
    position: absolute;

    img {
      width: 0.81vw;
    }
  }
}

// .img-box{
//   height: 91vh;
//   overflow: hidden;
//   background: url('../../../assets/images/浅色地图.png') no-repeat;
//   background-size: auto 100%;
//   background-position: center;

// }
.center_dark .img-box .warrning-map .alarm-right-tip {
  background: #244274;
  color: #FFFFFF;
  box-shadow: 0px 0px 9px 0px rgba(200, 200, 200, 0.18);
}

.center_dark {
  .header-box {
    .left-btn {
      span {
        color: #FFFFFF;
        background: #254E87;
        box-shadow: 0px 1.92px 8.06px 0px rgba(0, 0, 0, 0.07);
      }

      span.active {
        //  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.07);
        //  border-radius: 6px;
        //  border: 1px solid #2D74F5;
        color: #05E6FD;
        border: 1px solid #05E6FD;
      }
    }
  }

  .yuqing-time {
    font-size: 0.94vw;
    color: #FFF;
  }

  .h-time {
    span {
      color: #FFFFFF;
      background: #254E87;
      box-shadow: 0px 1.92px 8.06px 0px rgba(0, 0, 0, 0.07);
    }

    span.active {
      color: #05E6FD;
      border: 1px solid #05E6FD;
    }
  }
}

.yuqing-time {
  position: absolute;
  left: 1.04vw;
  top: 0vw;
  padding-left: 2.6vw;
  color: #666666;
}

.h-time {
  position: absolute;
  right: 1.04vw;
  height: 100%;
  display: flex;
  flex-direction: column;

  span {
    text-align: center;
    padding: 0.26vw 0vw;
    margin: 0.52vw 0vw;
    width: 3.96vw;
    font-size: 0.83vw;
    background: #FFF;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.07);
    color: #666666;
    border-radius: 0.31vw;

    &:hover {
      cursor: pointer;
    }
  }

  span.active {
    box-shadow: 0vw 0.1vw 0.42vw 0vw rgba(0, 0, 0, 0.07);
    color: #2D74F5;
    border: 0.05vw solid #2D74F5;
  }

}

.yubao-tuli {
  position: absolute;
  right: 1.04vw;
  bottom: 0vw;

  img {
    width: 4.32vw;
  }
}
</style>
